export default {
      id: "eye_closed-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "img/icons.dd84271a.svg#eye_closed",
      toString: function () {
        return this.url;
      }
    }